export default () => ({
  lastTransactions: [],
  payoutAmount: 0
});
